import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowRight, FaGlobeEurope, FaRocket, FaStar, FaTruck, FaUsers } from 'react-icons/fa';

const Apply = () => {
  const { t } = useTranslation();

  const trustItems = [
    { icon: FaUsers, value: '500+', label: t('apply.activeMembers') },
    { icon: FaTruck, value: 'ETS2 + ATS', label: t('apply.twoGames') },
    { icon: FaGlobeEurope, value: 'RU', label: t('apply.community') },
  ];

  return (
    <section className="apply-modern apply-upgraded">
      <div className="apply-grid-background" aria-hidden="true"></div>
      <div className="apply-ambient apply-ambient-left" aria-hidden="true"></div>
      <div className="apply-ambient apply-ambient-right" aria-hidden="true"></div>

      <div className="container apply-container">
        <div className="apply-panel">
          <div className="apply-copy">
            <div className="section-badge apply-badge">
              <FaStar aria-hidden="true" />
              <span>{t('apply.badge')}</span>
            </div>

            <h2>{t('apply.title')}</h2>
            <p>{t('apply.description')}</p>

            <div className="apply-cta-row">
              <a
                href="https://apply.mileageriot.com"
                target="_blank"
                rel="noopener noreferrer"
                className="apply-primary-cta"
              >
                <FaRocket aria-hidden="true" />
                {t('header.buttons.join')}
                <FaArrowRight aria-hidden="true" />
              </a>
              <Link to="/events" className="apply-secondary-cta">
                {t('apply.viewConvoys')}
                <FaArrowRight aria-hidden="true" />
              </Link>
            </div>

            <span className="apply-note">{t('apply.noExperience')}</span>
          </div>

          <div className="apply-trust-card" aria-label={t('apply.communityFacts')}>
            <div className="apply-trust-heading">
              <span>{t('apply.whyUsLabel')}</span>
              <h3>{t('apply.whyUs')}</h3>
            </div>

            <div className="apply-trust-grid">
              {trustItems.map(({ icon: Icon, value, label }) => (
                <div className="apply-trust-item" key={value}>
                  <span className="apply-trust-icon"><Icon aria-hidden="true" /></span>
                  <strong>{value}</strong>
                  <small>{label}</small>
                </div>
              ))}
            </div>

            <div className="apply-trust-footer">
              <span className="apply-live-dot" aria-hidden="true"></span>
              <span>{t('apply.recruiting')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Apply;
